import { createUserWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";
import { ref, get, set } from "firebase/database";
import { auth, db } from "../utils/db";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
import {
  IonButton,
  IonCardTitle,
  IonCol,
  IonContent,
  IonInput,
  IonInputPasswordToggle,
  IonLabel,
  IonPage,
  IonRouterLink,
  IonRow,
  IonText,
  useIonToast,
} from "@ionic/react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

export default function Register({ onRegister }) {
  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");
  const [senha, setSenha] = useState("");
  const [presentToast] = useIonToast();
  const history = useHistory();

  const isFormValid =
    nome.trim() !== "" && email.trim() !== "" && senha.trim() !== "";

  const register = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        senha
      );
      const user = userCredential.user;
      const userRef = ref(db, `users/${user.uid}`);
      const userSnap = await get(userRef);

      if (!userSnap.exists()) {
        await set(userRef, {
          email: user.email,
          name: nome,
          role: "jogador",
        });
      }

      onRegister(user);
      history.push("/login");
    } catch (err) {
      presentToast({
        header: "Erro ao logar",
        message: err.message,
        buttons: ["OK"],
      });
    }
  };

  return (
    <IonPage className="gray-page">
      <IonContent fullscreen className="center-content">
        <div className="ion-padding box">
          <IonRow>
            <IonCol size="12">
              <IonCardTitle>Cadastro</IonCardTitle>
            </IonCol>
          </IonRow>
          <IonRow className="ion-margin-top ion-padding-top">
            <IonCol size="12">
              <IonLabel>Nome</IonLabel>
              <IonInput
                placeholder="Nome"
                onChange={(e) => setNome(e.target.value)}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12">
              <IonLabel>Email</IonLabel>
              <IonInput
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12">
              <IonLabel>Senha</IonLabel>
              <IonInput
                placeholder="Senha"
                type="password"
                onChange={(e) => setSenha(e.target.value)}
              >
                <IonInputPasswordToggle color="tertiary" slot="end" />
              </IonInput>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12">
              <IonButton
                color="tertiary"
                expand="full"
                shape="round"
                disabled={!isFormValid}
                onClick={register}
              >
                Criar conta
              </IonButton>
            </IonCol>
          </IonRow>
          <IonRow className="ion-margin-top ion-padding-top">
            <IonCol size="12">
              <IonText>Você já tem uma conta?</IonText>
              <IonRouterLink className="link" href="/login">
                {" "}
                Clique aqui.
              </IonRouterLink>
            </IonCol>
          </IonRow>
        </div>
      </IonContent>
    </IonPage>
  );
}
